import { RootState } from "../../store.types";
import { State } from "./search.types";

export const getCurrentState = (state: RootState): State => state.search;

export const getSearch = (state: RootState) => getCurrentState(state).search;

export const isSearchLoading = (state: RootState) =>
  getCurrentState(state).isSearchLoading;

export const getResultList = (state: RootState) =>
  getCurrentState(state).resultList;

export const getResultDetail = (state: RootState) =>
  getCurrentState(state).resultDetail;

export const isAutoLoading = (state: RootState) =>
  getCurrentState(state).isAutoLoading;

export const automaticConfigElements = (state: RootState) =>
  getCurrentState(state).automaticConfigElements;

export const getAutoError = (state: RootState) => getCurrentState(state).error;

export const getAutoSuccess = (state: RootState) =>
  getCurrentState(state).success;
